import { z } from 'zod';

export const schemaErrorProcessingFailed = z.object({
    message: z.string().optional(),
    status: z.number().optional(),
});

export type SchemaErrorProcessingFailed = z.infer<typeof schemaErrorProcessingFailed>;
